import { Component, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import * as Chartist from 'chartist';
import { ActivityHistoryData } from '../../histories/history/history.component';
import { BackOffServiceService } from '../../services/back-off-service.service';
import { environment } from 'src/environments/environment';
import { LogsData } from '../../model/LogsData';
import * as Parse from 'parse';
import { Chart } from 'chart.js';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';


declare var $: any;
@Component({
  selector: 'app-docactivitytrend',
  templateUrl: './docactivitytrend.component.html',
  styleUrls: ['./docactivitytrend.component.css']
})
export class DocactivitytrendComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  buttonColor = ["primary", "primary", "primary", "primary", "primary", "default", "default"]
  buttonMessage = ["unlogged", "unlogged", "unlogged", "unlogged", "unlogged", "", ""]
  weekColor = true;
  monthColor = false;
  weekColor2 = true;
  monthColor2 = false;
  topMessage = "past week of data"
  botMessage = "past week of data"

  activityStack = [0,0,0,0,0,0,0];
  activityStack2 = [0,0,0,0,0,0,0,0];
  Activitylabels = Last7Days().reverse()
  Activitylabels2 = Last7Weeks().reverse()

  calStack = [0,0,0,0,0,0,0];
  calStack2 = [0,0,0,0,0,0,0,0];

  limitLine = [0,0,0,0,0,0,0,0];
  limitLine2 = [0,0,0,0,0,0,0,0];

  
  data: LogsData[];
  actMin = 0;
  minRem = 0;
  minExercised = 0;
  calGoal = 1000;
  calBurned = 0;
  calRem = 0;
  canvas: any;
  ctx1: any;
  ctx2: any;
  myChart: Chart;
  myChart2: Chart;
  @ViewChild('mychart') mychart;
  @ViewChild('mychart2') mychart2;

  patientId = this.cookie.get('patientId');

  constructor(
    private _bkoffService: BackOffServiceService,private breakpointObserver: BreakpointObserver,
    private router : Router,
    private cookie:CookieService,

  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }
  ngOnInit() {
  }
  
  ngAfterViewInit() {
    this.canvas = this.mychart.nativeElement; 
    this.ctx1 = this.canvas.getContext('2d');
    this.canvas = this.mychart2.nativeElement; 
    this.ctx2 = this.canvas.getContext('2d');

    this._bkoffService.getActivityCaloriesGoalCoach().then((res) => {
      this.calGoal = res;
      for (var i=0; i<this.limitLine2.length; i++){
        this.limitLine2[i]=res;
      }
    })

    this._bkoffService.getActivityGoalCoach().then((res) => {
      console.log("res is " + res);
      this.actMin = res;
      for (var i=0; i<this.limitLine.length; i++){
        this.limitLine[i]=res;
      }

      console.log("label 1="+this.Activitylabels[0])
      var ACTIVITY_DATA : ActivityHistoryData[] = [];
      var viewedDates = [];
      const today = new Date().getTime();
      var indexDay = today;
      var indexDay2 = today;
      var index = this.activityStack.length - 1;
      var index2 = this.activityStack2.length - 1;
      this._bkoffService.getActivityHistoryCoach().then((res) => {
        this.data = res;
        this.data.forEach(element => {
          console.log(element.activityDate);
          var d = this.getDay(element.activityDate);
          var m = this.getMonth(element.activityDate);
          var y = this.getYear(element.activityDate);
          var day = new Date(m + " " + d + ", " + y + " 00:00:00").getTime();
          //daily
          if (!(day < today - 604800000)) {
            const diff = Math.floor((indexDay - day) / 86400000);
            indexDay = day;
            if (index>=0){
              index -= diff;
              this.activityStack[index] += parseInt(element.time);
              console.log(element.activityCalories);
              if (element.activityCalories!=undefined){
                this.calStack[index] += element.activityCalories.valueOf();
              }
            }
          }
          else{
            console.log("longer than a week");
          }
          //weekly
          index2 = this.activityStack2.length - 1;
          if (!(day < today - 5184000000)) {
            const diff = Math.floor((today - day) / 604800000);
            console.log("diff: "+diff)
            indexDay2 = day;
            if (index2>=0){
              index2 -= diff;
              this.activityStack2[index2] += parseInt(element.time);
              console.log(element.activityCalories);
              if (element.activityCalories!=undefined){
                this.calStack2[index2] += element.activityCalories.valueOf();
              }
            }
          }
        });  
        console.log("weight stak is val "+ this.activityStack)
        let axisMin = 0;
        this.minExercised = this.activityStack.reduce((a, b) => a + b, 0);
        this.minRem = Math.max(0,this.actMin - this.minExercised);
        this.calBurned = this.calStack.reduce((a, b) => a + b, 0);
        this.calRem = Math.max(0,this.calGoal - this.calBurned);


        this.myChart = new Chart(this.ctx1, {
          type: 'bar',
          data: {
            labels: this.Activitylabels,
            datasets: [
              {
                label: "minutes exercised",
                type: "bar",
                backgroundColor: "rgba(52, 152, 219,0.4)",
                backgroundColorHover: "#000000",
                data: this.activityStack
              },
              {
                label: "goal",
                type: "line",
                borderColor: "rgb(255, 134, 78)",
                backgroundColor: "rgba(255, 134, 78, 0.5)",
                data: [],
                fill: false,
                borderWidth: 4,
            },
            ]
          },
          options: {
            title: {
              display: false,
              text: ''
            },
            scales: {
              xAxes: [{
                  stacked: true,
                  barPercentage: 0.6
              }],
              yAxes: [{
                  stacked: true,
              }]
            },
            legend: { display: false }
          }
      });

      this.myChart2 = new Chart(this.ctx2, {
        type: 'bar',
        data: {
          labels: this.Activitylabels,
          datasets: [
            {
              label: "calories",
              type: "bar",
              backgroundColor: "rgba(52, 152, 219,0.4)",
              backgroundColorHover: "#3e95cd",
              data: this.calStack
            },
            {
              label: "goal",
              type: "line",
              borderColor: "rgb(255, 134, 78)",
              backgroundColor: "rgba(255, 134, 78, 0.5)",
              data: [],
              fill: false,
              borderWidth: 4,
          },
          ]
        },
        options: {
          title: {
            display: false,
            text: ''
          },
          scales: {
            xAxes: [{
                stacked: true,
                barPercentage: 0.6
            }],
            yAxes: [{
                stacked: true,
            }]
          },
          legend: { display: false }
        }
    });
    });
    });
  }
  
    getDay(date : string) : string {
      var res = date.split(" ");
      var day = res[1];
      res = day.split(",");
      day = res[0];
      return day;
    }

    getMonth(date : string) : string {
      var res = date.split(" ");
      return res[0];
    }

    getYear(date : string) : string {
      var res = date.split(" ");
      return res[3];
    }


    getToday() : Number {
      var d = new Date();
      var day = Number(d.getDate());
      return day;
    }

    toggleWeek(){
      if(!this.weekColor){
        this.weekColor = !this.weekColor;
        this.monthColor = !this.monthColor;
        console.log("week toggled")
        this.myChart.data.labels = this.Activitylabels
        this.myChart.data.datasets[0].data = this.activityStack
        this.myChart.data.datasets[1].data = []
        this.myChart.options.legend.display = false
        this.myChart.update();
        this.topMessage = "past week of data"
      }
    }

    toggleMonth(){
      if(!this.monthColor){
        this.weekColor = !this.weekColor;
        this.monthColor = !this.monthColor;
        console.log("month toggled")
        this.myChart.data.labels = this.Activitylabels2
        this.myChart.data.datasets[0].data = this.activityStack2
        this.myChart.data.datasets[1].data = this.limitLine
        this.myChart.options.legend.display = true
        this.myChart.update();
        this.topMessage = "past 2 months of data"
      }
    }

    toggleWeek2(){
      if(!this.weekColor2){
        this.weekColor2 = !this.weekColor2;
        this.monthColor2 = !this.monthColor2;
        this.myChart2.data.labels = this.Activitylabels
        this.myChart2.data.datasets[0].data = this.calStack
        this.myChart2.data.datasets[1].data = []
        this.myChart2.options.legend.display = false
        this.myChart2.update();
        this.botMessage = "past week of data"
      }
    }

    toggleMonth2(){
      if(!this.monthColor2){
        this.weekColor2 = !this.weekColor2;
        this.monthColor2 = !this.monthColor2;
        this.myChart2.data.labels = this.Activitylabels2
        this.myChart2.data.datasets[0].data = this.calStack2
        this.myChart2.data.datasets[1].data = this.limitLine2
        this.myChart2.options.legend.display = true
        this.myChart2.update();
        this.botMessage = "past 2 months of data"
      }
    }

    toLogs(){
      this.router.navigateByUrl('/logs');
    }

}


 function formatDate(date){

    var dd = date.getDate();
    var mm = date.getMonth()+1;
    var yyyy = date.getFullYear();
    if(dd<10) {dd='0'+dd}
    if(mm<10) {mm='0'+mm}
    date = mm.toString()+'/'+dd.toString();
    return date
 }

function Last7Days () {
  var result = [];
  for (var i=0; i<7; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push( formatDate(d) )
  }

  return(result);
}

function Last7Weeks () {
  var result = [];
  for (var i=0; i<8; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i*7);
      result.push( formatDate(d) )
  }

  return(result);
}

function minWeight (weightArray){
  var min = 100000
  for (var i=0; i<weightArray.length;i++){
    if (weightArray[i]<min && weightArray[i]!=0){
      min = weightArray[i]
    }
  }
  return min;
}